import { createSelector } from "reselect"
import { initialState } from "./reducer"

/**
 * Direct selector to the dashboard state domain
 */

const selectDashboardDomain = (state) =>
  state.get("dashboard-leader", initialState)

export const makeSelectIsLoadingProfile = () =>
  createSelector(selectDashboardDomain, (state) => state.get("loading_profile"))

export const makeSelectProfileLeader = () =>
  createSelector(selectDashboardDomain, (state) => state.get("profile_leader"))

export const makeSelectLoadingDashboard = () =>
  createSelector(selectDashboardDomain, (state) =>
    state.get("loading_dashboard")
  )

export const makeSelectPendingSurveys = () =>
  createSelector(selectDashboardDomain, (state) => state.get("pending_surveys"))

export const makeSelectDashboardData = () =>
  createSelector(selectDashboardDomain, (state) => state.get("dashboard"))
/**
 * Other specific selectors
 */

/**
 * Default selector used by Dashboard
 */

const makeSelectDashboard = () =>
  createSelector(selectDashboardDomain, (substate) => substate.toJS())

export default makeSelectDashboard
export { selectDashboardDomain }
